import $ from 'jquery';

//TODO some kind of dev env check before setting this up

$(document).on('click', '.js-btn-ersm-dismiss', event => {
  const $container = $(event.target).closest('.js-ersm-container');
  const $content = $container.find('.js-ersm-content-wrapper');
  $container.replaceWith($content.html());
});